module.exports = __webpack_public_path__ + "static/media/contactPhoto.1f59bfc4.jpg";